import * as JitsiConferenceEvents from 'lib-jitsi-meet/dist/esm/JitsiConferenceEvents';
import JitsiParticipant from 'lib-jitsi-meet/dist/esm/JitsiParticipant';

const JitsiConference = {
    applyOverride(jitsiConference) {
        jitsiConference.myJid = function() {
            return (
                this.room
                && this.room.myroomjid
                    ? this.room.myroomjid
                    : null);
        };

        /**
         * Sends text message to the other participants in the conference
         * @param message the text message.
         * @param elementName the element name to encapsulate the message.
         * @deprecated Use 'sendMessage' instead. TODO: this should be private.
         */
        jitsiConference.sendTextMessage = function(
                message, elementName = 'body') {
            if (this.room) {
                const profile = {
                    nick: (this.room.getFromPresence('nick') || {}).value,
                    displayName: (this.room.getFromPresence('displayName') || {}).value,
                    avatar: (this.room.getFromPresence('avatar-url') || {}).value,
                    ctijid: (this.room.getFromPresence('ctijid') || {}).value,
                    userId: Strophe.getResourceFromJid(this.myJid())
                };

                this.room.sendMessage(message, elementName, profile);
            }
        };

        /**
         * Send private text message to another participant of the conference
         * @param id the id of the participant to send a private message.
         * @param message the text message.
         * @param elementName the element name to encapsulate the message.
         * @deprecated Use 'sendMessage' instead. TODO: this should be private.
         */
        jitsiConference.sendPrivateTextMessage = function(
                id, message, elementName = 'body') {
            if (this.room) {
                const profile = {
                    nick: (this.room.getFromPresence('nick') || {}).value,
                    displayName: (this.room.getFromPresence('displayName') || {}).value,
                    avatar: (this.room.getFromPresence('avatar-url') || {}).value,
                    ctijid: (this.room.getFromPresence('ctijid') || {}).value,
                    userId: Strophe.getResourceFromJid(this.myJid())
                };

                this.room.sendPrivateMessage(id, message, elementName, profile);
            }
        };

        /**
         * Notifies this JitsiConference that a new member has joined its chat room.
         *
         * FIXME This should NOT be exposed!
         *
         * @param jid the jid of the participant in the MUC
         * @param nick the display name of the participant
         * @param role the role of the participant in the MUC
         * @param isHidden indicates if this is a hidden participant (system
         * participant for example a recorder).
         * @param statsID the participant statsID (optional)
         * @param status the initial status if any
         * @param identity the member identity, if any
         * @param botType the member botType, if any
         * @param fullJid the member full jid, if any
         * @param features the member botType, if any
         * @param isReplaceParticipant whether this join replaces a participant with
         * the same jwt.
         */

        // eslint-disable-next-line max-params
        jitsiConference.onMemberJoined = function(
                jid, nick, role, isHidden, statsID, status, identity, botType, fullJid, features, isReplaceParticipant, isSilent, ctijid) {

            const id = Strophe.getResourceFromJid(jid);

            if (id === 'focus' || this.myUserId() === id) {
                return;
            }

            const participant
                = new JitsiParticipant(jid, this, nick, isHidden, statsID, status, identity);

            participant.setConnectionJid(fullJid);
            participant.setRole(role);
            participant.setBotType(botType);
            participant.setFeatures(features);
            participant.setIsReplacing(isReplaceParticipant);

            participant.setProperty('ctijid', ctijid);

            this.participants.set(id, participant);
            this.eventEmitter.emit(
                JitsiConferenceEvents.USER_JOINED,
                id,
                participant);

            this._updateFeatures(participant);

            // maybeStart only if we had finished joining as then we will have information for the number of participants
            if (this.isJoined()) {
                this._maybeStartOrStopP2P();
            }

            this._maybeSetSITimeout();
        };

        jitsiConference.getLocalParticipantProperty = function(name) {
            if (!this.room) {
                return undefined;
            }
            const property = this.room.presMap.nodes.find(prop => prop.tagName === `jitsi_participant_${name}`);

            return property ? property.value : undefined;
        };
    }
};

export default JitsiConference;
